/* exported StorefrontHandler */

class StorefrontHandler {
    /**
     * @param   {string}    endpoint
     * @param   {string}    token
     */
    constructor(endpoint, token) {
        this.endpoint = endpoint;
        this.token = token;
    }

    /**
     * Query the Shopify Storefront API.
     *
     * @param   {Object}    body
     * @param   {string}    body.query
     * @param   {Object}    body.[variables]
     * @return  {Promise<Object|null>}
     */
    async query(body) {
        try {
            const response = await fetch(this.endpoint, {
                method: 'POST',
                headers: {
                    'X-Shopify-Storefront-Access-Token': this.token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            const { data } = await response.json();

            return data;
        } catch (err) {
            console.warn('Unable to fetch graphql with query', body.query, err);

            return null;
        }
    }
}
